module.exports = __webpack_public_path__ + "static/img/third2_1_5_active.44c40c1c.jpg";